


























export default

	props:
		card: Object


